import { useEffect, useState } from "react";

import { CustomPageRenderer } from "@hl/shared-features/lib/features/builder/CustomPageRenderer";
import { Box } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";

import { Curation, useMockServer } from "./builder/_mock";

export const PreviewCuration = () => {
  const navigate = useNavigate();
  const { curationId } = useParams();
  const { getCuration } = useMockServer();
  const [curation, setCuration] = useState<Curation | null>(null);

  console.log("Curation ID", curationId, curation);
  useEffect(() => {
    const loadCuration = async () => {
      try {
        if (curationId == null) {
          throw new Error("Curation ID is required");
        }
        const curation = await getCuration(curationId);
        setCuration(curation);
      } catch (error) {
        console.error("Error loading curation", error);
        // navigate("/404");
      }
    };

    loadCuration();
  }, [curation, curationId, getCuration, navigate]);

  if (curation == null) {
    return <div>Loading...</div>;
  }

  return (
    <Box>
      <CustomPageRenderer
        cssString={curation.draft.css}
        htmlString={curation.draft.html}
      />
    </Box>
  );
};
